import type {
  CrremDisplayMetric,
  CrremSettings,
  CrremTrendMethod,
  EnergyAnalysisDimension,
  EnergyAnalysisMixChartType,
  EnergyAnalysisSplitDimension,
  EnergyAnalysisTotalChartType,
  EnergyAnalysisTrendChartType,
} from "./types";

export const ENERGY_ANALYSIS_TOP_KPI_COUNT = 3;

export const ENERGY_ANALYSIS_DIMENSION = {
  corrections: "corrections",
  joint: "joint",
  mix: "mix",
  useType: "useType",
  utility: "utility",
} as const;

export const ENERGY_ANALYSIS_SPLIT_DIMENSION = {
  useType: "useType",
  utility: "utility",
} as const;

export const CRREM_TREND_METHOD = {
  average: "average",
  regression: "regression",
} as const;

export const CRREM_DISPLAY_METRIC = {
  co2: "co2",
  kwh: "kwh",
} as const;

export const DEFAULT_CRREM_SETTINGS: CrremSettings = {
  climateCorrectionEnabled: false,
  coverageCorrectionEnabled: false,
  displayMetric: "kwh",
  trendMethod: "average",
  vacancyCorrectionEnabled: false,
};

export const ENERGY_ANALYSIS_TOTAL_CHART_TYPE = {
  barHorizontal: "barHorizontal",
  barVertical: "barVertical",
  doughnut: "doughnut",
  kpi: "kpi",
} as const;

export const ENERGY_ANALYSIS_TREND_CHART_TYPE = {
  line: "line",
  stackedBar: "stackedBar",
  stackedPercent: "stackedPercent",
} as const;

export const ENERGY_ANALYSIS_MIX_CHART_TYPE = {
  heatmap: "heatmap",
  sankey: "sankey",
  sunburst: "sunburst",
  treemap: "treemap",
} as const;

export const isEnergyAnalysisDimension = (value: string): value is EnergyAnalysisDimension =>
  value === ENERGY_ANALYSIS_DIMENSION.corrections ||
  value === ENERGY_ANALYSIS_DIMENSION.joint ||
  value === ENERGY_ANALYSIS_DIMENSION.mix ||
  value === ENERGY_ANALYSIS_DIMENSION.useType ||
  value === ENERGY_ANALYSIS_DIMENSION.utility;

export const isEnergyAnalysisSplitDimension = (value: string): value is EnergyAnalysisSplitDimension =>
  value === ENERGY_ANALYSIS_SPLIT_DIMENSION.useType || value === ENERGY_ANALYSIS_SPLIT_DIMENSION.utility;

export const isEnergyAnalysisTotalChartType = (value: string): value is EnergyAnalysisTotalChartType =>
  value === ENERGY_ANALYSIS_TOTAL_CHART_TYPE.barHorizontal ||
  value === ENERGY_ANALYSIS_TOTAL_CHART_TYPE.barVertical ||
  value === ENERGY_ANALYSIS_TOTAL_CHART_TYPE.doughnut ||
  value === ENERGY_ANALYSIS_TOTAL_CHART_TYPE.kpi;

export const isEnergyAnalysisTrendChartType = (value: string): value is EnergyAnalysisTrendChartType =>
  value === ENERGY_ANALYSIS_TREND_CHART_TYPE.line ||
  value === ENERGY_ANALYSIS_TREND_CHART_TYPE.stackedBar ||
  value === ENERGY_ANALYSIS_TREND_CHART_TYPE.stackedPercent;

export const isEnergyAnalysisMixChartType = (value: string): value is EnergyAnalysisMixChartType =>
  value === ENERGY_ANALYSIS_MIX_CHART_TYPE.heatmap ||
  value === ENERGY_ANALYSIS_MIX_CHART_TYPE.sankey ||
  value === ENERGY_ANALYSIS_MIX_CHART_TYPE.sunburst ||
  value === ENERGY_ANALYSIS_MIX_CHART_TYPE.treemap;

export const isCrremTrendMethod = (value: unknown): value is CrremTrendMethod =>
  value === CRREM_TREND_METHOD.average || value === CRREM_TREND_METHOD.regression;

export const isCrremDisplayMetric = (value: unknown): value is CrremDisplayMetric =>
  value === CRREM_DISPLAY_METRIC.co2 || value === CRREM_DISPLAY_METRIC.kwh;
